import AbstractPlatformWindow, {
    PlatformWindowGetSizeResponse
} from "~/operatorApplication/ts/platform/AbstractPlatformWindow";
import {OperatorConfigStore} from "~/operatorApplication/ts/store/OperatorConfigStore";

export const FAVICON_ID = "operator-application-favicon";

const NEW_MESSAGE_FAVICON = `data:image/x-icon;base64,AAABAAEAEBAAAAAAIABoBAAAFgAAACgAAAAQAAAAIAAAAAEAIAAAAAAAQAQAAAAAAAAAAAAAAAAAAAAAAAD///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////ATrO+aVP1/2vLc/9rR/N/K0RyvytBMf8rQLE/K0HwfutCr/7rQy8+q0OufqtD7f5rRG0+a0TsfmtFLP+rxSk7aUAxPv/RdL7/1zb//831P//KdH//xrO//8KzP//Acn//wPG//8Hwv7/Cr/+/wu8/f8Ou/3/D7z//xCr7/8TpOz/B8v/8QDF+/9Q1Pr/ad3//0LV//810v7/Js///xjS//8K0///AMj//wTE/v8Jwv7/CsT//wyy7/8RqOz/E7T+8SLP//MMzP//Acb7/1jV+/913///S9f//0bc//81yPP/H7jj/xXU//8DzP//As3//wi58f8OrOz/Ebj//xG2/PMv0v7xKND+/xHN//8Hx/v/Ydf7/4rp//9f1fP/Gqzx/xGV2/8ttNj/KeD//w3D9f8Ir+3/Drz//w66/f8Pt/vxP9T+8TXT/v8u0f7/Fs7//xfP//9p0u//MLbu/wGw/v8PtP//HaDf/yiqzP8Lv/b/CMP//wu//f8MvPz/Dbr88U7X//NE1f7/OtT//zvY//8mx/P/ALLu/wS5//8Puv3/Ebj8/xK3//8Mltj/A6fX/wfM//8Kw///Cr79/wu9/PNd2v7zU9j//1Lb//9DzPL/DL3w/wDD//8Iwf7/C779/w27/P8Oufz/E7v//xCf3v8EqNb/Bs3//wnE//8KwP3zbN3/8Wjf//9c0PL/JcPw/wLN//8Cyv//A8b+/wfC/v8KwP3/C739/w27/f8SvP//DqDe/wSp1v8Fzv//CMb/8YDk//Fw1PL/Rsrw/y/U//8o0f//F83+/wjL//8ByP7/A8X+/wjC/f8Lv/3/DL39/xG+//8Nod3/BKrX/wTP//GH2PL/a9Hw/1rc//9S2f//Q9X+/zXS//8l0P//FM3//wfK//8CyP7/BsT+/wnB/f8LwP7/D8H//w2l3v8Gq9j/kNv0tYXk/8F54P+/atz+v1va/r9N1/6/P9T+vzDR/r8gz/6/EMz+vwTK/r8Fxv6/B8P9vwnC/r8Nw//BDavltf///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8B////Af///wH///8BAAD//wAA//8AAP//AAD//wAA//8AAP//AAD//wAA//8AAP//AAD//wAA//8AAP//AAD//wAA//8AAP//AAD//w==`;
//"assets/operatorApplication/images/newMessage.ico";

export default class WebPlatformWindow extends AbstractPlatformWindow {
    blinkMessageIconInterval: any;
    isShowMessageFavicon: boolean = false;
    initialFavicon: string;


    async resize(width: number, height: number, center: boolean = true): Promise<void> {
    }

    async move(x: number, y: number): Promise<void> {
    }

    async minimize(): Promise<void> {
        return Promise.resolve(undefined);
    }

    async getSize(): Promise<PlatformWindowGetSizeResponse> {
        return {
            width: window.outerWidth,
            height: window.outerHeight,
            maximized: false,
            minimized: false
        }
    }

    async openDevTools(): Promise<void> {

    }

    setBadge(value?: number) {
        if (value > 0) {
            if (!this.blinkMessageIconInterval) {
                this.blinkMessageIconInterval = setInterval(() => {
                    this.setFavicon(!this.isShowMessageFavicon);
                }, 500);
            }
        } else {
            if (this.blinkMessageIconInterval) {
                clearInterval(this.blinkMessageIconInterval);
                this.blinkMessageIconInterval = null;
                this.setFavicon(false);
            }
        }
    }

    private setFavicon(newMessage: boolean) {
        this.isShowMessageFavicon = newMessage;
        let src = newMessage ? NEW_MESSAGE_FAVICON : OperatorConfigStore.faviconSrc.value;
        let favicon: HTMLLinkElement = document.getElementById(FAVICON_ID) as any;
        if (favicon) {
            favicon.href = src;
        }
    }
}